export default "__VITE_ASSET__4705eceb__"